<template>
<div class="content">
  <q-card>
    <div class="row">
        <div class="col-xs-11">
          <q-btn class="button float-right" @click="newUser()" color="primary" :label="$t('global.NewEmployee')" />
        </div>
    </div>
    <div class="row">
      <div class="col">&nbsp;</div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <q-table
          :title="$t('global.CurrentEmployees')"
          :data="Users"
          :columns="columnsUsers"
          row-key="IdUser"
          :dense=true
          selection="single"
          :selected.sync="selectedRowsEvent"
          :loading="loading"
          :pagination.sync="paginationControl" 
          >

        <template slot="top-selection" slot-scope="props" >
          <div class="q-table-title">{{$t('global.CurrentEmployees')}}</div>
          <div v-if="selectedRowsEvent[0].CanDelete == true">
            <q-btn color="secondary" flat :label="$t('global.Delete')" @click="deleteUser()" />
          </div>
          <div>
            <q-btn color="secondary" flat :label="$t('global.Edit')" @click="editUser()" />
          </div>
        </template>
        <q-td slot="body-cell-IsHourlyWage" slot-scope="props" :props="props">
          <q-checkbox v-model="props.row.IsHourlyWage" disable  />
        </q-td>
        <q-td slot="body-cell-IsActive" slot-scope="props" :props="props">
          <q-checkbox v-model="props.row.IsActive" disable  />
        </q-td>
      
        </q-table>
      </div>
    </div>
    </q-card>
</div>

</template>

<script>
import axios from 'axios'
import qs from 'qs'
import {eventBus} from '../../main'
import { date } from 'quasar'

export default {
  name: 'UserList',
  data: function () {
    return {
      loading: false,
      form: {
        SessionId: null,
        action: 'GetUsers',
        IdLanguage: 1
      },
      Users:[],
      selectedRowsEvent: [],  
      columnsUsers: [
      {
        name: 'FirstName', required: true, label: this.$t('global.NameFirst'), align: 'left',
        field: 'FirstName',sortable: true
      },
      {
        name: 'LastName', required: true,label: this.$t('global.Name'), align: 'left',
        field: 'LastName',sortable: true
      },
      {
        name: 'Email', required: true,label: this.$t('global.UserEmail'), align: 'left',
        field: 'Email',sortable: true
      },
      {
        name: 'UserCategory', required: true,label: this.$t('global.Category'), align: 'left',
        field: 'UserCategory',sortable: true
      },
      {
        name: 'Address', required: true,label: this.$t('global.Address'), align: 'left',
        field: 'Address',sortable: true
      },
      {
        name: 'IsHourlyWage', required: true,label: this.$t('global.HourlyWage'), align: 'center',
        field: 'IsHourlyWage',sortable: true
      },
      {
        name: 'HourlyWage', required: true,label: this.$t('global.HourlyWage'), align: 'right',
        field: 'HourlyWage',sortable: true,
        format: val => this.decFormat(val)
      },
      {
        name: 'MonthlyWage', required: true,label: this.$t('global.MonthlyWage'), align: 'right',
        field: 'MonthlyWage',sortable: true,
        format: val => this.decFormat(val)
      },  
      {
        name: 'HoursMonthlyWage', required: true,label: this.$t('global.HoursMonth'), align: 'right',
        field: 'HoursMonthlyWage',sortable: true,
      },  
      {
        name: 'Comment', required: true,label: this.$t('global.Comment'), align: 'left',
        field: 'Comment',sortable: true,
      },  
      {
        name: 'IsActive', required: true,label: this.$t('global.Active'), align: 'center',
        field: 'IsActive',sortable: true
      },
      ],
      columnHeaders: ['global.NameFirst','global.Name','global.UserEmail','global.Category','global.Address','global.HourlyWage','global.HourlyWage','global.MonthlyWage','global.HoursMonth','global.Comment','global.Active'],
      paginationControl: { rowsPerPage: 15, page: 1 },
    }
    
  },
  methods: {
    loadUsers(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetUsers"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.Users = response.data
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    deleteUser(){
      var self = this
      this.$q.dialog({
        title: this.$t('global.DeleteEntry'),
        message: this.$t('global.DeleteEntryQuestion'),
        color: 'primary',
        ok: true, // takes i18n value, or String for "OK" button label
        cancel: true, // takes i18n value, or String for "Cancel" button label
        preventClose: true,
        noBackdropDismiss: false, // gets set to "true" automatically if preventClose is "true"
        noEscDismiss: false, // gets set to "true" automatically if preventClose is "true"
        stackButtons: false,
        position: 'top',        
      })
      .then(() => {
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "DeleteUser"
        this.form.IdUser = this.selectedRowsEvent[0].IdUser
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
              this.$q.notify({ message: 'Mitarbeiter gelöscht', type: 'positive' })
              this.loadUsers()
              this.selectedRowsEvent = []
              eventBus.$emit('Bus_UserUpdate', null)
            }
            else{
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {
          this.$q.notify('Something Wrong.')
          console.log(e);
        })
      })
      .catch(() => {
        //alert('Picked cancel')
      })
    },
    editUser(){
      eventBus.$emit('Bus_EditUser', this.selectedRowsEvent[0].IdUser)
    },
    dateFormat(val) {
     if(val == null){
        return null
      }
      return this.moment(val).format(this.$store.state.session.DateTimeFormat)
    },
    decFormat(val) {
      return val.toFixed(2)
    },
    newUser(){
       eventBus.$emit('Bus_EditUser', null)
    }

  },
  created () {
    this.loadUsers()
    eventBus.$on('Bus_UserUpdate', (data) => {
      this.loadUsers()
    }),
    eventBus.$on('Bus_ChangeLocale', (data) => {
      var cnr = 0
      this.columnHeaders.forEach(col => {
      this.columnsUsers[cnr].label = this.$t(col)
      cnr++
      })
    })
  },
  computed: {
  },
}
</script>
<style scoped>
.content{
  padding: 10px;
}
.titel{
  text-align: center;
}
</style>